module.exports = __webpack_public_path__ + "static/media/payment.97a79f42.svg";